(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["or-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('or-product-spotlight')) {
    customElements.define(
      'or-product-spotlight',
      class OrProductSpotlight extends HTMLElement {
        constructor() {
          super();
          this.track = this.querySelector('.or-product-spotlight__track');
          this.items = Array.from(this.querySelectorAll('.or-product-spotlight__product'));
          this.previousButton = this.querySelector('[name="previous"]');
          this.nextButton = this.querySelector('[name="next"]');
          this.desktopMedia = window.matchMedia('(min-width: 990px)');

          if (!this.track || !this.previousButton || !this.nextButton || this.items.length < 4) return;

          this.previousButton.addEventListener('click', () => this.move(-1));
          this.nextButton.addEventListener('click', () => this.move(1));
          this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
          this.desktopMedia.addEventListener('change', () => this.reset());

          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        requestUpdate() {
          if (this.updateFrame) return;
          this.updateFrame = requestAnimationFrame(() => {
            this.updateFrame = null;
            this.update();
          });
        }

        itemPosition(item) {
          const firstItem = this.items[0];
          return this.desktopMedia.matches ? item.offsetTop - firstItem.offsetTop : item.offsetLeft - firstItem.offsetLeft;
        }

        scrollPosition() {
          return this.desktopMedia.matches ? this.track.scrollTop : this.track.scrollLeft;
        }

        currentIndex() {
          const position = this.scrollPosition();
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          this.items.forEach((item, index) => {
            const distance = Math.abs(this.itemPosition(item) - position);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          return closestIndex;
        }

        move(direction) {
          const destinationIndex = Math.max(0, Math.min(this.items.length - 3, this.currentIndex() + direction));
          const destination = this.itemPosition(this.items[destinationIndex]);
          const scrollOptions = this.desktopMedia.matches ? { top: destination } : { left: destination };
          scrollOptions.behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.track.scrollTo(scrollOptions);
        }

        reset() {
          this.track.scrollTo({ top: 0, left: 0, behavior: 'auto' });
          requestAnimationFrame(() => this.update());
        }

        update() {
          const index = this.currentIndex();
          this.previousButton.disabled = index <= 0;
          this.nextButton.disabled = index >= this.items.length - 3;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
